const SPOdds = 'SP'

import { parseEachWayFraction } from './eachWayFraction';

export function calculateTax(betslip, wagerTax, wagerTaxType: 'add' | 'deduct') {
  const isSP = betslip.odds == SPOdds;
  const isEachWay = betslip.eachWayBet;

  const taxOnWager = isEachWay ? betslip.amount * wagerTax * 2 : betslip.amount * wagerTax;
  let wagerAfterTax = 0;
  let possibleWinnings: number | string = SPOdds;
  let totalPaidAmount = 0;

  if (wagerTaxType === 'add') {
    totalPaidAmount = isEachWay ? (betslip.amount) * 2 + taxOnWager : betslip.amount + taxOnWager;
    wagerAfterTax = isEachWay ? betslip.amount * 2 : betslip.amount;
  } else {
    totalPaidAmount = isEachWay ? betslip.amount * 2 : betslip.amount;
    wagerAfterTax = isEachWay ? (betslip.amount - (taxOnWager / 2)) * 2 : betslip.amount - taxOnWager;
  }

  // calculate possible winnings
  const totalWin = isSP ? SPOdds :
    isEachWay ?
      ((betslip.odds * wagerAfterTax) + (((betslip.odds - 1) * parseEachWayFraction(betslip.eachWayFraction) + 1) * wagerAfterTax)) :
      betslip.odds * wagerAfterTax
  possibleWinnings = isSP ? SPOdds : totalWin;

  return {
    totalPaidAmount,
    taxOnWager,
    wagerAfterTax,
    possibleWinnings,
  }
}

export function calculateWithMRAModel(betslip, wagerTax, wagerTaxType: 'add' | 'deduct') {
  const isSP = betslip.odds == SPOdds;
  const isEachWay = betslip.eachWayBet;

  let taxOnWager = 0;
  let wagerAfterTax = 0;
  let possibleWinnings: number | string = SPOdds;
  let totalPaidAmount = 0;

  wagerAfterTax = isEachWay ? (betslip.amount / (Number(wagerTax) + 1)) * 2 : (betslip.amount / (Number(wagerTax) + 1));
  taxOnWager = wagerAfterTax * Number(wagerTax);

  if (wagerTaxType === 'add') {
    totalPaidAmount = isEachWay ? (betslip.amount) * 2 + taxOnWager : betslip.amount + taxOnWager;
  } else {
    totalPaidAmount = isEachWay ? betslip.amount * 2 : betslip.amount;
  }

  // calculate possible winnings
  const totalWin = isSP ? SPOdds :
    isEachWay ?
      ((betslip.odds * wagerAfterTax) + (((betslip.odds - 1) * parseEachWayFraction(betslip.eachWayFraction) + 1) * wagerAfterTax)) :
      betslip.odds * wagerAfterTax
  possibleWinnings = isSP ? SPOdds : totalWin;

  return {
    totalPaidAmount,
    taxOnWager,
    wagerAfterTax,
    possibleWinnings,
  }
}

export function calculateTaxWithMRAModel(amount: number, wagerTax: number, isEachWay: boolean) {
  const wagerAfterTax = isEachWay ? amount / (Number(wagerTax) + 1) * 2 : amount / (Number(wagerTax) + 1);
  const taxOnWager = wagerAfterTax * Number(wagerTax);

  return {
    taxOnWager,
    wagerAfterTax,
  }
}

export function calculateTotalPaidAmount(
  currentTab: 'SINGLE' | 'MULTIPLE',
  betslips: any[],
  wagerTaxType: 'add' | 'deduct',
  wagerTax: number,
  totalStakeMultiple: number,
  eachWayBetMultiple = false
) {
  if (currentTab === 'SINGLE') {
    return betslips.reduce((total, item) => {
      const multiplier = item.eachWayBet ? 2 : 1;
      const amount = +item.amount * multiplier;
      const tax = wagerTaxType === 'add' ? item.tax : 0;
      return total + amount + tax;
    }, 0);
  } else {
    const multiplier = eachWayBetMultiple ? 2 : 1;
    const baseStake = totalStakeMultiple * multiplier;
    const taxOnWager = wagerTaxType === 'add' ? (totalStakeMultiple * wagerTax) * multiplier : 0;
    return baseStake + taxOnWager;
  }
}

export function calculatePossibleWinnings(
  currentTab: 'SINGLE' | 'MULTIPLE',
  betslips: any[],
  wagerTaxType: 'add' | 'deduct',
  wagerTax: number,
  totalStakeMultiple: number,
  eachWayBetMultiple = false
) {
  if (betslips.some(x => x.odds == null || x.odds === 'SP')) {
    return 'SP';
  }

  if (currentTab === 'SINGLE') {
    return betslips.reduce((acc, betslip) => acc + Number(betslip.possibleWinnings), 0);
  } else {
    const odds = betslips.reduce((acc, betslip) => acc * Number(betslip.odds), 1);
    if (wagerTaxType === 'add') {
      return odds * (eachWayBetMultiple ? totalStakeMultiple * 2 : totalStakeMultiple);
    } else {
      const taxOnWager = totalStakeMultiple * wagerTax;
      const totalStakeAfterTax = eachWayBetMultiple ? totalStakeMultiple * 2 - taxOnWager : totalStakeMultiple - taxOnWager;
      return odds * totalStakeAfterTax;
    }
  }
}
